export const DEFAULT_LINK_ERROR =
  'This upload link is invalid. Please request a new link from your closer.';

export const DEFAULT_UPLOAD_ERROR =
  'There was an error uploading your document(s). Please try again.';

/** Pulls the backend ValidationException message out of a rejected Service call. */
export const getApiErrorMessage = (e: any, fallback: string): string =>
  e?.error?.response?.data?.error?.message || fallback;
